// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".balloon[data-v-6b2a65cb] {\n  padding: 6px;\n  background: #fdfcf4 0% 0% no-repeat padding-box;\n  border-radius: 20px;\n  opacity: 1;\n}", ""]);
// Exports
module.exports = exports;
